import { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";

function useHasUserAgrmt() {
  const user = useSelector((state) => state.user);
  const [agrmt, setAgrmt] = useState([]);

  const getAgrmt = async () => {
    await axios.get("/api/v1/hwts/user/check/useragrmt").then((res) => {
      setAgrmt(res.data);
    });
  };

  useEffect(() => {
    if (user.isAuth === true) {
      getAgrmt();
    } else {
      setAgrmt([false]);
    };
  }, []);
  return agrmt;
}

export default useHasUserAgrmt;